import { string, object } from 'yup';
import salesTypes from 'maps/sales-types';

import supportsOneOf from 'helpers/supportsOneOf';

// Use the map of salesType as a single source of truth for possible values
// We can always still exclude some of these values if needed from the schema
const salesTypeKeys = Object.keys(salesTypes);

// This validation schemas is written for the TerritoryTable component

/**
 * @returns {method} A yup schema to be used for validation
 */
function getSchema(salesType) {
  if (!salesType) {
    throw new Error(
      'You forgot to pass salesType to the getSchema function for territoryTable. We can not create a default value without that argument.'
    );
  }

  const schema = object({
    selectedSalesType: string()
      .required()
      .default(() => salesTypes[salesType].value),
  });

  if (supportsOneOf()) {
    schema.fields.selectedSalesType = schema.fields.selectedSalesType.concat(
      string().oneOf(salesTypeKeys)
    );
  }

  return schema;
}

export default getSchema;
